<template>
  <el-form
    :model="contractForm"
    ref="contractFormRef"
    label-width="80px"
    :disabled="disabled"
    :rules="rules"
  >
    <el-form-item label="合同名称" prop="contractName">
      <el-input
        v-model="contractForm.contractName"
        placeholder="请输入合同名称"
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item label="合同编码" prop="contractCode">
      <el-input
        v-model="contractForm.contractCode"
        placeholder="请输入合同编码"
        style="width: 100%"
      />
    </el-form-item>
    <!-- 签署方一  本账号 不可编辑 -->
    <el-form-item label="签署方一" prop="draftShopName">
      <el-input
        v-model="contractForm.draftShopName"
        placeholder="请选择签署方"
        :disabled="true"
      />
    </el-form-item>
    <el-form-item label="签署方二" prop="coopShopId">
       <el-input
        v-if="disabled"
        v-model="contractForm.coopShopName"
        placeholder="请输入合同编码"
        style="width: 100%"
      />
      <ContractSignSelect
        v-else
        ref="contractSignSelectRefSecond"
        :signUserId="contractForm.coopShopId"
        :signUserName="contractForm.coopShopName"
        @changeSignUser="changeSignUser"
      />
    </el-form-item>
  </el-form>
</template>
<script>
import ContractSignSelect from "./contract-sign-select.vue";
export default {
  components: {
    ContractSignSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    shopId: {
      type: String,
      default: "",
    },
    shopName: {
      type: String,
      default: "",
    },
  },
  watch: {
    shopId: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.contractForm.draftShopId = newVal;
          this.contractForm.draftShopName = this.shopName;
          this.contractForm.draftShopUserName = this.shopName;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      contractForm: {
        contractName: "", //合同名称
        contractCode: "", //合同编码  
        draftShopName: "", //拟稿商户名
        draftShopId: "", //拟稿商户id
        draftShopUserName: "", //拟稿商户用户名
        coopShopId: "", //合作cso商户id
        coopShopName: "", //合作cso商户名
      },
      rules: {
        contractName: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
        ],
        contractCode: [
          { required: true, message: "请输入合同编码", trigger: "blur" },
        ],
        coopShopId: [
          { required: true, message: "请选择签署方二", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    initForm(item){
        this.contractForm.contractName = item.contractName;
        this.contractForm.contractCode = item.contractCode;
        this.contractForm.coopShopId = item.coopShopId;
        this.contractForm.coopShopName = item.coopShopName;
    },
    getForm() {
      return new Promise((resolve, reject) => {
        this.$refs.contractFormRef.validate((valid) => {
          if (valid) {
            resolve(this.contractForm);
          } else {
            reject(null);
          }
        });
      });
    },
    resetForm() {
      for (let key in this.contractForm) {
        this.contractForm[key] = "";
      }
      this.$refs.contractFormRef.clearValidate();
      this.$refs.contractSignSelectRefSecond.reset();
    },
    changeSignUser(val) {
      this.contractForm.coopShopId = val.value;
      this.contractForm.coopShopName = val.label;
    },
  },
};
</script>